var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.1,14.1L9.2,8L3.1,1.9L4.9,0l8,8l-8,8L3.1,14.1z","fill":"currentColor"}));
}

ChevronRight.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
